<template>
    <section>
        <div v-if="Object.keys(singleVisit).length > 0" class="visit-view" ref="capture">
            <chillNavbar class="no-print" path_title="current_visit_and_craft" :current_visit="singleVisit.store_name_app" :craft="singleVisit.craft" :org="user_home_client" />
            <div id="pdf-btns" class="button-box">
                <button v-if="!report_downloading" class="no-print button-box-element" @click="getReport()">{{trans("generate_report")}} <chill-icon class="dark new-tab-one-icon" size="small-icon" icon="arrow_down_filled"/></button>
                <button v-else-if="!downloadingPDF" class="no-print button-box-element" ><loadingDots /></button>
                <!-- <button class="no-print button-box-element" @click="getErrorReport()">{{trans("generate_error_report")}} <chill-icon class="dark new-tab-one-icon" size="small-icon" icon="arrow_down_filled"/></button> -->
                <button  v-if="showErrorReport()" class="no-print button-box-element" @click="getErrorReport()">{{trans("generate_error_report")}} <chill-icon class="dark new-tab-one-icon" size="small-icon" icon="arrow_down_filled"/></button>
                
                <JspdfGenerator 
                    :visitStrucutre="checklistStrucuture" 
                    :visitData="visit_local_data" 
                    :checklistTypes="checklistOrder()" 
                    :allCLStruct="allChecklistStrucutre" 
                    :t="trans"
                    :order="numbers_more_than_zero(listOfTypes)"
                    :marketData="singleMarket"
                     />
                <!-- <button class="no-print button-box-element" onclick='downloadURI("data:text/html,HelloWorld!", "helloWorld.txt");'>{{trans('downlaod_as_html')}}</button> -->
                <button class="no-print button-box-element" @click="share_modal = true" >{{trans("share_visit")}} <chill-icon class="dark new-tab-one-icon" size="small-icon" icon="arrow_right_filled"/></button>
                <!-- <button class="no-print button-box-element" onclick="this.href='data:text/html;charset=UTF-8,'+encodeURIComponent(document.documentElement.outerHTML)" href="#" download="page2.html">{{trans('downlaod_as_html')}}</button> -->
            </div>
            <div ref="general" class="visit-general-data">

                <div class="button-box">
                </div>
                <p>{{trans('visit_data_here')}}</p>
                <div v-for="(key,i) in checklistOrderToShow" :key="key+i" class="visit-form-element">
                    <div v-if="statementCheck(checklistStrucuture[key])" :class="'form-field-'+checklistStrucuture[key].type+ ' ' +'form-field-row'">
                        <h3 class="title">{{trans(key)}}</h3>

                        <input v-if="checklistStrucuture[key].type === 'string'  && statementCheck(checklistStrucuture[key])" :disabled="true" v-model="visit_local_data[key]" type="text" name="" id="" class="input-field">
                        <input v-else-if="checklistStrucuture[key].type === 'int'  && statementCheck(checklistStrucuture[key])" :disabled="true" v-model="visit_local_data[key]" type="number" class="input-field">
                        <div v-else-if="checklistStrucuture[key].type === 'list'  && statementCheck(checklistStrucuture[key])" class="list-type-element">
                            <listType asd="asd" :value="visit_local_data[key]" :disabled="true" v-model="visit_local_data[key]"></listType>
                        </div>
                        <span v-else-if="checklistStrucuture[key].type === 'bool' && statementCheck(checklistStrucuture[key])" class="bool-element">
                            <label><input type="radio"  :disabled="true" value="yes" v-model="visit_local_data[key]" id="one">{{trans('yes')}}</label>
                            <label><input type="radio" :disabled="true" value="no" v-model="visit_local_data[key]" id="two">{{trans('no')}}</label>
                        </span>
                        <v-select v-else-if="checklistStrucuture[key].type === 'option'  && statementCheck(checklistStrucuture[key])" :id="'select-'+key" :disabled="true" v-model="visit_local_data[key]" :options="genereateOptions(checklistStrucuture[key].options)" :reduce="o => o.value" label="key"/>
                        <Datepicker class="date" inputClass="date-input" v-else-if="checklistStrucuture[key].type === 'date' && statementCheck(checklistStrucuture[key])" v-model="visit_local_data[key]" placeholder="dd/mm/yyyy" format="dd.MM.yyyy" type="timestamp" :disabled="true"></Datepicker>
                    </div>
                </div>
            </div>

            
            <div
                v-for="(type, i) in numbers_more_than_zero(listOfTypes)"
                :key="i+type"
                class="visit-checklist-data"
            >
                <span v-if="showChecklist(type).length > 0">{{trans(type)}}</span>
                <div class="visit-checklist" v-for="(check, ii) in showChecklist(type)" :key=ii>
                    <div class="visit-checklist-row-visit">
                        <div class="checklist-row-box" @click="gotoChecklist(check)">
                            <img v-if="check.front_image" class="checklist-row-image" :src="check.front_image" alt="" >
                            <img v-else class="checklist-row-no-image" src="@/assets/no-image-icon.png" alt="" >
                            <div class="checklist-row-text">
                                <span class="row-text">{{check.name}}</span>
                                <span v-if="check.checklist_id && !check.done && check.started" class="row-text">{{trans('started')}}</span>
                                <span v-else-if="check.checklist_id && check.done" class="row-text">{{trans('done_checklists')}}</span>
                                <span v-else class="row-text">{{trans('not_done')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <modal
                v-if="share_modal"
                component="shareModal"
                :componentprops="{header: trans('share_this_with'), btnPrimary: trans('send'), btnSecondary: trans('cancel')}"
                @agree="share_modal = false" 
                @disagree="share_modal = false"
            />
        </div>
        <div v-else class="visit-view" ref="capture">
            <chillNavbar class="no-print" path_title="current_visit_and_craft" :current_visit="singleVisit.store_name_app" :craft="singleVisit.craft" :org="user_home_client" />
            <div ref="general" class="visit-general-data" style="text-align:center">
                <p>{{trans('no_access_you_are_not_in_the_correct_client')}}</p>
            </div>
        </div>
    </section>
</template>

<script>
    // import exportFromJSON from 'export-from-json'
    import * as Excel from "exceljs";
    import { saveAs } from "file-saver"
    import JspdfGenerator from "../components/pdf/jspdfGenerator.vue";
    import errorPDFReport from "../components/pdf/errorPdf.js"
    
    export default {
    name: "done_visit",
    data() {
        return {
            newChecklistType: false,
            visit_general_data: "",
            visit_local_data: {},
            showModal: false,
            share_modal: false,
            data_loaded: false,
            deleteModal: false,
            delete_checklist_key: "",
            report_downloading: false,
            downloadingPDF: false
        };
    },
    computed: {
        checklistOrderToShow() {
            if (this.checklistStrucuture?.order) {
                const filtredOrder = this.checklistStrucuture.order.filter(key => {
                    return this.statementCheck(this.checklistStrucuture[key]) ? key : null;
                });
                return filtredOrder;
            }
            else {
                return "";
            }
        },
        checklistsStartedCount() {
            let temp = {};
            for (let c of this.checklists) {
                temp[c.type] = temp[c.type] ? temp[c.type] + 1 : 1;
            }
            return temp;
        },
        possible_amount_count() {
            let re = 0;
            for (let c of Object.values(this.singleVisit.count)) {
                re += c;
            }
            return re;
        },
    },
    watch: {
        singleVisit() {
            this.data_loaded = true;
            this.startListOfTypes(this.singleVisit.craft);
            this.visit_local_data = this.singleVisit;
        },
        "$route"(to) {
            if (to.name != "checklist" || to.name != "count") {
                this.clearVisitData();
            }
        }
    },
    methods: {
        test(e){
            return e
        },
        getPathName() {
            return window.location.pathname;
        },
        checklistOrder() {
            let filtredOrder = [];
            if (this.singleVisit.craft == "ventilation") {
                filtredOrder = [];
            }
            else if (this.singleVisit.craft == "hvacasdasd") {
                filtredOrder = [];
            }
            else if (this.singleVisit.craft == "hvacasdasd2") {
                filtredOrder = [];
            }
            let re = [...this.checklists];
            // console.log("FILTER =========")
            // console.log(re)
            re = re.filter(clx => clx.done)
            // console.log(re)
            // console.log("end =========")
            re.sort((a, b) => {
                return filtredOrder[a.type] > filtredOrder[b.type];
            });
            return this.checklists;
        },
        showErrorReport(){
            for(let cl of this.checklists){
                if(Object.values(cl).includes("not_working")) return  true
            }
            return false
        },
        getErrorReport(){
            let errors = []
            for(let cl of this.checklists){
                if(Object.values(cl).includes("not_working")){
                    errors.push(cl)
                }
            }

            errorPDFReport.pdf(errors, this.allChecklistStrucutre, this.trans, {...this.singleVisit, craftman_company: this.trans(this.singleVisit.craftman_company)},this.singleMarket)


        },
        getReport() {
            let vm = this;
            this.report_downloading = true;
            const requestOptions = {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ api_token: "e4afef8f-e2e4-49db-b10d-b5517fb406f2", visit_id: this.$route.params.visit_id })
            };
            fetch("https://us-central1-chillchecklist.cloudfunctions.net/createCsv", requestOptions)
                .then(response => response.text())
                .then(data => {
                let na = vm.singleVisit?.store_name_app.replaceAll(".", "").replaceAll(",", "").replaceAll(" ", "_");
                const moment = require("moment");
                const d = new Date(vm.singleVisit.locked_at);
                let da = moment(d).format("YYYYMMDD");
                const fileName = da + "_" + na + "_" + this.trans(vm.singleVisit?.craft);
                data = JSON.parse(data);
                const workbook = new Excel.Workbook();
                const workSheetName = "Komponentenliste";
                const workSheetName2 = "Wartungsplan";
                const columns = [
                    { header: "Kostenstelle", key: "Kostenstelle" },
                    { header: "pos", key: "pos" },
                    { header: "Lieferant", key: "Lieferant" },
                    { header: "Leistung", key: "Leistung" },
                    { header: "Menge", key: "Menge" },
                    { header: "WPL Zyklus", key: "WPL Zyklus" },
                    { header: "Zyklusstart", key: "Zyklusstart" },
                    { header: "SAP Text", key: "SAP Text" },
                    { header: "Benennung", key: "Benennung" }
                ];
                const columns2 = [
                    { header: "Kostenstelle", key: "Kostenstelle" },
                    { header: "pos", key: "pos" },
                    { header: "Lieferant", key: "Lieferant" },
                    { header: "Leistung", key: "Leistung" },
                    { header: "Menge", key: "Menge" },
                    { header: "WPL Zyklus", key: "WPL Zyklus" },
                    { header: "Zyklusstart", key: "Zyklusstart" },
                    { header: "SAP Text", key: "SAP Text" }
                ];
                const worksheet = workbook.addWorksheet(workSheetName, { pageSetup: { paperSize: 9 } });
                const worksheet2 = workbook.addWorksheet(workSheetName2, { pageSetup: { paperSize: 9 } });
                worksheet.columns = columns;
                worksheet2.columns = columns2;

                worksheet.getRow(1).font = { bold: true };
                worksheet.columns.forEach(column => {
                    column.width = column.header.length + 25;
                    column.alignment = { horizontal: "left" };
                });
                data.forEach(singleData => {
                    let temp = { ...singleData };
                    worksheet.addRow(temp);
                });
                worksheet.eachRow({ includeEmpty: true }, row => {
                    const borderStyles = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    };
                    row.eachCell({ includeEmpty: true }, function (cell) {
                        cell.style.border = borderStyles;
                    });
                });



                let temp = []
                for(let d of data){
                    if(d.Leistung && d.Leistung === temp[temp.length-1]?.Leistung){
                        let t =  temp[temp.length-1]
                        t.Menge++;
                        t.Benennung = t.Benennung + ", " + d.Benennung
                        temp[temp.length-1] = t
                    }else{
                        temp.push(d)
                    }
                }
                
                worksheet2.getRow(1).font = { bold: true };
                worksheet2.columns.forEach(column => {
                    column.width = column.header.length + 25;
                    column.alignment = { horizontal: "left" };
                });
                temp.forEach(singleData => {
                    let temp = { ...singleData };
                    worksheet2.addRow(temp);
                });
                worksheet2.eachRow({ includeEmpty: true }, row => {
                    const borderStyles = {
                        top: { style: "thin" },
                        left: { style: "thin" },
                        bottom: { style: "thin" },
                        right: { style: "thin" }
                    };
                    row.eachCell({ includeEmpty: true }, function (cell) {
                        cell.style.border = borderStyles;
                    });
                });




                workbook.xlsx.writeBuffer().then(buf => {
                    saveAs(new Blob([buf]), `${fileName}.xlsx`);
                    vm.report_downloading = false;
                });
            });
        },
        gotoChecklist(data) {
            this.$router.push(`/done_checklist/${this.$route.params.market_id}/${this.$route.params.visit_id}/${data.checklist_id}`);
        },
        genereateOptions(options) {
            let re = [];
            for (let o of options) {
                re.push({ key: this.trans(o), value: o });
            }
            return re;
        },
        statementCheck(struct) {
            if (struct && struct.statement) {
                if (struct.statement.type == "equal") {
                    if (this.singleVisit[struct.statement.key] == struct.statement.value) {
                        return true;
                    }
                }
                else if (struct.statement.type == "greater_than") {
                    if (this.singleVisit[struct.statement.key] > struct.statement.value) {
                        return true;
                    }
                }
            }
            else {
                return true;
            }
        },
        check_checklistOrderToShow(type) {
            if (this.allChecklistStrucutre && this.allChecklistStrucutre[type]?.order) {
                const filtredOrder = this.allChecklistStrucutre[type].order.filter(key => {
                    return this.statementCheck(this.allChecklistStrucutre[type][key], key) ? key : null;
                });
                return filtredOrder;
            }
            else {
                return "";
            }
        },
        numbers_more_than_zero(lista) {
            let temp = [];
            let pre_sort = [];
            for (let l of lista) {
                if (this.singleVisit.count[l] > 0) {
                    pre_sort.push({ trans: parseInt(this.trans(l).split(".")[1]), value: l });
                    //temp.push(l)
                }
            }
            pre_sort.sort((a, b) => (a.order > b.order) ? 1 : -1);
            for (let ps of pre_sort) {
                temp.push(ps.value);
            }
            return temp.reverse();
        },
        showChecklist(type) {
            if (!type) {
                return [];
            }
            let temp = this.checklists.filter(x => x.type === type && x.done);
            return temp;
        },
    },
    mounted() {
        this.startSingleVisitListener(this.$route.params.visit_id);
        this.startChecklistListener(this.$route.params.visit_id);
        this.startComponentListener(this.$route.params.market_id);
        this.startChecklistStrucutre("visit");
        this.startAllChecklistStrucutre();
        this.startSpecialCaseUserListener(this.getUser().uid);
        this.startSingleMarketListener(this.$route.params.market_id)
    },
    components: { JspdfGenerator }
}
</script>

<style lang="scss">
    .visit-view {
        margin: 150px auto 0px auto;
        width: 86vw;
        max-width: 900px;
        .visit-general-data {
            border-radius: 4px;
            margin-bottom: 20px;
            .visit-form-element {
                width: 100%;
                margin: 8px 0px;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                border-left: solid #1B608C 5px;
                width: 100%;
                padding: 0px 8px 12px 8px;
                box-sizing: border-box;
                .form-field-row {
                    width: 100%;
                    .input-field {
                        border: none;
                        border-bottom: solid #565760 1px;
                        &:focus {
                            outline: none;
                            border-bottom: solid #51D07D 1px;
                        }
                    }
                    .bool-element {
                        display: flex;
                        margin: 0px 12px;
                        > label {
                            display: flex;
                            flex-direction: column-reverse;
                            width: 33%;
                            &:nth-child(2) {
                                align-items: center;
                            }
                        }
                    }
                    .vdp-datepicker  {
                        width: 100% !important;
                        > div > .date-input {
                            border: none !important;
                            border-bottom: solid #565760 1px !important;
                        }
                    }
                    .select-field {
                        height: 28px;
                        border: solid #191A23 1px;
                        border-radius: 4px;
                        color: #1B608C;
                        height: 30px;
                        padding-left: 8px;
                        width: 100%;
                    }
                }
            }
        }
        .visit-checklist-data {
            border-color: #51D07D;
            border-radius: 4px;
            margin-bottom: 20px;
            .checklist-row-data {
                .visit-row {
                    margin: 8px 0px;
                    height: 56px;
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                    border-left: solid #1B608C 5px;
                    background-color: #fff;
                    box-sizing: border-box;
                    // border-radius: 4px;
                    &:hover {
                        cursor: pointer;
                    }
                    .visit-text {
                        margin: auto;
                        /* flex: 2; */
                        margin-left: 8px;
                    }
                    .number-of-components {
                        margin-top: auto;
                        margin-bottom: auto;
                        margin-right: 12px;
                    }
                    .hide-show-arrow {
                        width: auto;
                        height: 14px;
                        margin: auto 8px;
                    }
                    .hide {
                        // margin-bottom: 200px;
                        display: none;
                    }
                    .arrow-box {
                        margin-top: auto;
                        margin-bottom: auto;
                    }
                }
                .active {
                    border-left: solid #4FC4F0 5px !important;
                }
            }
            .visit-checklist {
                display: flex;
                flex-direction: column;
                align-items: flex-end;
                .visit-checklist-row-visit {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    .checklist-row-delete {
                        display: flex;
                        justify-content: center;
                        width: 50px;
                        margin-left: 8px;
                        background-color: #fff;
                        > i {
                            margin-bottom: auto;
                        }
                    }
                    .checklist-row-box {
                        border-left: solid #1B608C 5px;
                        margin-bottom: 1px;
                        width: calc(100% - 30px);
                        height: 60px;
                        display: flex;
                        justify-content: space-between;
                        background-color: #fff;
                        &:hover {
                            cursor: pointer;
                            border-left: solid #4FC4F0 5px;
                        }
                        .checklist-row-image {
                            object-fit: cover;
                            width: 56px;
                            height: 56px;
                            margin: auto 2px
                        }
                        .checklist-row-no-image {
                            width: 60px;
                            height: 60px;
                        }
                        .checklist-row-text {
                            display: flex;
                            flex-direction: column;
                            align-items: flex-end;
                            .row-text {
                                margin: auto 8px;
                            }
                        }
                    }
                }
            }
            .hide {
                display: none;
            }
            .text-area {
                width: calc(100% - 12px);
                &:focus {
                    outline: none;
                    border-bottom: solid #51D07D 1px;
                }
            }
            .textarea-bottom {
                height: 100px;
                border: none;
                border-bottom: solid #565760 1px;
                &:focus {
                    outline: none;
                    border-bottom: solid #51D07D 1px;
                }
            }
            .extra-comment {
                width: 100%;
                margin: 8px 0px;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                border-left: solid #1B608C 5px;
                padding: 0px 8px 12px 8px;
                box-sizing: border-box;
                > label {
                    width: 100%;
                }
            }
        }
    }
    .button-box {
        width: 100%;
        .button-box-element {
            width: 200px;
            background-color: #1B608C;
            color: #FFF;
            height: 28px;
            border-radius: 28px;
            border: none;
            margin-top: 8px;
            &:hover {
                cursor: pointer;
            }
        }
    }

    span {
        font-size: 14px;
    }

     .title {
        font-size: 14px;
        color: #191A23;
        font-weight: 300;
        margin: 4px;
    }
    h3 {
        font-weight: normal;
        font-size: 16px;
        margin-top: 0px;
    }
    input[type=text], input[type=number], textarea {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
        font-weight: 300;
        height: 30px;
        padding-left: 8px;
        font-size: 14px;
        width: calc(100% - 14px);
    }
    input[type="radio"] {
        margin: 0px;

    }
    button {
        font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
    }
    h3 {
        font-weight: normal;
        font-size: 16px;
    }
    p {
        font-size: 14px;
    }
    .remove {
        display: none;
    }
    .blocked {
        border-left: solid #ECEDF0 5px !important;
        color: #CBCCD5;
    }
    .visit-row-blocked {
        margin: 8px 0px;
        height: 56px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        // border-left: solid black 5px;
        background-color: #fff;
        box-sizing: border-box;
        border-left: solid #ECEDF0 5px !important;
        color: #CBCCD5;
        .visit-text {
            margin: auto;
            /* flex: 2; */
            margin-left: 8px;
        }
        .number-of-components {
            margin-top: auto;
            margin-bottom: auto;
            margin-right: 12px;
        }
        .hide-show-arrow {
            width: auto;
            height: 14px;
            margin: auto 8px;
        }
        .hide {
            display: none;
        }
        .arrow-box {
            margin-top: auto;
            margin-bottom: auto;
        }
    }    

</style>


// <style lang="scss">
//     @page 
//     {
//         size:  auto;   /* auto is the initial value */
//         margin: 2mm;  /* this affects the margin in the printer settings */
//     }
//     @media print
//     {    
//         .no-print, .no-print *
//         {
//             display: none !important;
//         }
//         .show-on-print {display: block !important;}
//     }
//     .disabled {
//       pointer-events:none;
//       color: #bfcbd9;
//       cursor: not-allowed;
//       background-image: none;
//       background-color: #eef1f6;
//       border-color: #d1dbe5;   
//     }
//     .visit-view {
//         margin: 150px auto 0px auto;
//         width: 86vw;
//         max-width: 900px;
//         .hide-pdf-nav {
//             display: none;
//         }
//         .visit-general-data {
//             border-radius: 4px;
//             margin-bottom: 20px;
//             .visit-form-element {
//                 width: 100%;
//                 margin: 8px 0px;
//                 background-color: #fff;
//                 display: flex;
//                 justify-content: space-between;
//                 border-left: solid #1B608C 5px;
//                 width: 100%;
//                 padding: 0px 8px 12px 8px;
//                 box-sizing: border-box;
//                 .form-field-row {
//                     width: 100%;
//                     .input-field {
//                         border: none;
//                         border-bottom: solid #565760 1px;
//                         &:focus {
//                             outline: none;
//                             border-bottom: solid #51D07D 1px;
//                         }
//                     }
//                     .bool-element {
//                         display: flex;
//                         margin: 0px 12px;
//                         > label {
//                             display: flex;
//                             flex-direction: column-reverse;
//                             width: 33%;
//                             &:nth-child(2) {
//                                 align-items: center;
//                             }
//                         }
//                     }
//                     .vdp-datepicker  {
//                         width: 100% !important;
//                         > div > .date-input {
//                             border: none !important;
//                             border-bottom: solid #565760 1px !important;
//                         }
//                     }
//                     .select-field {
//                         height: 28px;
//                         border: solid #191A23 1px;
//                         border-radius: 4px;
//                         color: #1B608C;
//                         height: 30px;
//                         padding-left: 8px;
//                         width: 100%;
//                     }
//                 }
//             }
//         }
//         .visit-checklist-data {
//             border-radius: 4px;
//             margin-bottom: 20px;
//             .checklist-row-data {
//                 .visit-row {
//                     margin: 8px 0px;
//                     height: 56px;
//                     width: 100%;
//                     display: flex;
//                     justify-content: space-between;
//                     border-left: solid #1B608C 5px;
//                     background-color: #fff;
//                     // border-radius: 4px;
//                     &:hover {
//                         cursor: pointer;
//                     }
//                     .visit-text {
//                         margin: auto;
//                         /* flex: 2; */
//                         margin-left: 8px;
//                     }
//                     .number-of-components {
//                         margin-top: auto;
//                         margin-bottom: auto;
//                     }
//                     .hide-show-arrow {
//                         width: auto;
//                         height: 14px;
//                         margin: auto 8px;
//                     }
//                     .hide {
//                         display: none;
//                     }
//                 }
//                 .active {
//                     border-left: solid #4FC4F0 5px !important;
//                 }
//             .visit-checklist {
//                 display: flex;
//                 .visit-checklist-row {
//                     display: flex;
//                     flex-direction: column;
//                     width: 100%;
//                     .checklist-box {
//                         display: flex;
//                         flex-direction: column;
//                         margin-bottom: 8px;

//                         background-color: #fff;
//                         justify-content: space-between;
//                         border-left: solid #1B608C 5px;
//                         width: 100%;
//                         padding: 0px 8px 12px 8px;
//                         box-sizing: border-box;
//                         .checklist-box-info {
//                             display: flex;
//                             flex-direction: column;
//                             margin-bottom: 8px;
//                         }
//                         .checklist-box-image {
//                             /* overflow: hidden; */
//                             display: flex;
//                             justify-content: space-between;
//                             .checklist-box-image-left {
//                                 text-align: center;
//                             }
//                             .checklist-box-image-right {
//                                 align-items: center;
//                                 display: flex;
//                                 flex-direction: column;
//                                 .un-change-image {
//                                     display: flex;
//                                     flex-direction: column;
//                                     align-items: center;
//                                 }
//                                 .small-image {
//                                     width: 110px;
//                                     height: 110px;
//                                     border-radius: 4px;
//                                 }
//                             }
//                         }
//                     }
//                     .form-field-row {
//                         width: 100%;
//                         margin: 8px 0px;
//                         background-color: #fff;
//                         display: flex;
//                         justify-content: space-between;
//                         border-left: solid #1B608C 5px;
//                         padding: 0px 8px 12px 8px;
//                         box-sizing: border-box;
//                         .form-field-input {
//                             width: 100%;
//                             // .input-field { }
//                         }
//                         .input-field {
//                             border: none;
//                             border-bottom: solid #565760 1px;
//                             &:focus {
//                                 outline: none;
//                                 border-bottom: solid #51D07D 1px;
//                             }
//                         }
//                         .form-field-box {
//                             width: 100%;
//                             .bool-element {
//                                 display: flex;
//                                 margin: 0px 12px;
//                                 > label {
//                                     display: flex;
//                                     flex-direction: column-reverse;
//                                     width: 33%;
//                                     &:nth-child(2) {
//                                         align-items: center;
//                                     }
//                                 }
//                             }
//                             .input-field {
//                                 border: none;
//                                 border-bottom: solid #565760 1px;
//                                 &:focus {
//                                     outline: none;
//                                     border-bottom: solid #51D07D 1px;
//                                 }
//                             }
//                             .checkbox-field {
//                                 display: flex;
//                                 flex-direction: column;
//                                 justify-content: space-between;
//                                 padding-bottom: 4px;
//                                 .checklist-choices-box {
//                                     display: flex;
//                                     justify-content: space-between;
//                                     align-items: center;
//                                     margin-right: 10px;
//                                     margin-left: 10px;
//                                     .checkbox-box {
//                                         display: flex;
//                                         align-items: center;
//                                         flex-direction: column;
//                                         margin-bottom: 4px;
//                                         > label {
//                                             display: flex;
//                                             flex-direction: column;
//                                             align-items: center
//                                         }
//                                         .check-left {
//                                             align-items: flex-start;
//                                         }
//                                         .check-center {
//                                             align-items: center;
//                                         }
//                                         .check-right {
//                                             align-items: flex-end;
//                                         }
//                                     }
//                                 }
//                             }
//                             .image-content-image {
//                                 margin-left: auto;
//                                 margin-bottom: 4px;
//                             }
//                             textarea {
//                                 padding-top: 4px;
//                                 border: none;
//                                 border-bottom: solid #565760 1px;
//                                 border-radius: 0px;
//                                 &:focus {
//                                     outline: none;
//                                     border-bottom: solid #51D07D 1px;
//                                 }
//                             }
//                         }
//                         .general-comment {
//                             display: flex;
//                             flex-direction: column;
//                             width: 100%;
//                             .textarea-bottom {
//                                 height: 100px;
//                                 border: none;
//                                 border-bottom: solid #565760 1px;
//                                 border-radius: 0px;
//                                 &:focus {
//                                     outline: none;
//                                     border-bottom: solid #51D07D 1px;
//                                 }
//                             }
//                         }
//                     }
//                 }
//             }
//             .hide {
//                 display: none;
//             }
//             .text-area {
//                 width: calc(100% - 2px);
//                 &:focus {
//                     outline: none;
//                     border-bottom: solid #51D07D 1px;
//                 }
//             }
//             .textarea-bottom {
//                 height: 100px;
//                 border: none;
//                 border-bottom: solid #565760 1px;
//                 &:focus {
//                     outline: none;
//                     border-bottom: solid #51D07D 1px;
//                 }
//             }
//             }
//         }
//     }
//     .button-box {
//         width: 100%;
//         .button-box-element {
//             display: inline-flex;
//             align-items: center;
//             justify-content: center;
//             width: 200px;
//             background-color: #1B608C;
//             color: #FFF;
//             height: 28px;
//             border-radius: 28px;
//             border: none;
//             margin-top: 8px;
//             margin-right: 8px;
//             > i {
//                 margin-left: 8px;
//             }
//             &:hover {
//                 cursor: pointer;
//             }
//         }
//     }

//     span {
//         font-size: 14px;
//     }

//      .title {
//         font-size: 14px;
//         color: #191A23;
//         font-weight: 300;
//         margin: 4px;
//     }
//     h3 {
//         font-weight: normal;
//         font-size: 16px;
//         margin-top: 0px;
//     }
//     input[type=text], input[type=number], textarea {
//         font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
//         font-weight: 300;
//         height: 30px;
//         padding-left: 8px;
//         font-size: 14px;
//         width: calc(100% - 14px);
//     }
//     input[type="radio"] {
//         margin: 0px;

//     }
//     button {
//         font-family: 'Yantramanav', Verdana, Arial, Helvetica, sans-serif;
//     }
//     h3 {
//         font-weight: normal;
//         font-size: 16px;
//     }
//     p {
//         font-size: 14px;
//     }

//     .vue-html2pdf {
//         margin: 150px auto 0px auto !important;
//         width: 86vw !important;
//         max-width: 900px !important;
//     }

// </style>